module.exports = __webpack_public_path__ + "static/media/white-diamonds.eb45d2b7.svg";